import styled from '@emotion/styled';
import { BodySmallLink, Row } from '../../styles';
import { Box } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { isCompact, isExpanded, Breakpoint } from '../../types';

const FooterSection = styled(Box, shouldForwardProps)<{
    breakpoint: Breakpoint;
}>`
    display: flex;
    flex-direction: row;
    gap: ${({ breakpoint, theme }) => (isExpanded(breakpoint) ? theme.spacing(5) : 0)};
    justify-content: space-between;
    align-items: ${({ breakpoint }) => (isCompact(breakpoint) ? 'center' : 'flex-start')};
    width: ${({ breakpoint }) => (isExpanded(breakpoint) ? '' : '100%')};
    padding: ${({ theme }) => theme.spacing(2)};
`;

const BottomContainer = styled(Box, shouldForwardProps)<{
    breakpoint: Breakpoint;
}>`
    width: 100%;
    display: flex;
    flex-direction: ${({ breakpoint }) => (isCompact(breakpoint) ? 'column' : 'row')};
    justify-content: space-between;
    gap: ${({ theme, breakpoint }) =>
        isCompact(breakpoint) ? theme.spacing(2) : theme.spacing(5)};
`;

const WrapContainer = styled(Row, shouldForwardProps)<{
    breakpoint: Breakpoint;
}>`
    gap: ${({ theme, breakpoint }) =>
        isCompact(breakpoint) ? theme.spacing(1) : theme.spacing(5)};
    flex-wrap: wrap;
    align-items: center;
`;

const FooterLink = styled(BodySmallLink)`
    color: ${({ theme }) => theme.colors.onPrimaryDark};
`;

export { FooterSection, FooterLink, BottomContainer, WrapContainer };
